import React, { Component, CSSProperties } from "react";
import { IAirlineVoucherCodesParameter, Istate } from "../../../Model/IAirlineVendorCodes";
import {FormLabel,Container,Row,Col,Form,Alert,Button,Card,NavLink,FormControl,Table,InputGroup,FormGroup} from "react-bootstrap";
import {FormModalSpinner} from '../../CustomComponents/FormModalSpinner';
import { FormSelect } from "../../CustomComponents/FormSelect";
import { FormInputs } from "../../CustomComponents/FormInput";
import { BCDcodeMaintenanceController } from "../../../Controllers/BCDcodeMaintenanceController";
import '../../../assets/css/Style.css'
import { format } from 'date-fns'
import ReactPaginate from 'react-paginate';
import { MultilineDropdown } from "react-multiline-dropdown";
import { alert, confirm } from 'react-bootstrap-confirmation';


export class AirlineVendorCodes extends Component<IAirlineVoucherCodesParameter,Istate> {
    constructor(props:IAirlineVoucherCodesParameter){
        super(props)
        const userLogin = sessionStorage.getItem("userLogin")
        let loggedIn = true;
        if (userLogin == null){
            loggedIn = false;
        }
        this.state={  
            fields: {id:'',name:'',searchId:'',searchName:'',isEdit:false,isIDSearch:true,isNameSearch:true},
            selectfields:{},
            errors:{id:'',name:''},
            errMsg:"",
            loading:false,            
            modal: {modalSpinnerShow: false},           
            userId:sessionStorage.getItem("uid"),
            airlineVendorCodesGroups:[],             
            offset: 0,
            tableData: [],                  
            perPage: 10,
            currentPage: 0,
            pageCount:0
        } 
        this.handlePageClick = this.handlePageClick.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);        
        this.onClear = this.onClear.bind(this);
    }

    handleTextChange(e:any){  
        let fields = this.state.fields;
        let errors = this.state.errors;
        fields[e.currentTarget.id] = e.currentTarget.value; 
        errors[e.currentTarget.id] = "";
        if(fields["id"] === "")
        {
            fields["isEdit"]=false;
        } 
        if(fields["searchId"] != "")
        {
            fields["isIDSearch"]=true;
            fields["isNameSearch"]=false;
        }
        if(fields["searchName"] != "")
        {
            fields["isIDSearch"]=false;
            fields["isNameSearch"]=true;
        }
        if(fields["searchName"] === "" && fields["searchId"] === "")
        {
            fields["isIDSearch"]=true;
            fields["isNameSearch"]=true;
        }
            
        this.setState({fields,errors});       
    }

    componentWillMount(){
        let modal = this.state.modal;        
        this.setState({userId:sessionStorage.getItem("uid")})
        modal['modalSpinnerShow']=true; 
        this.getAirlineVendorCodeList();
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;

        this.setState({
            currentPage: selectedPage,
            offset: offset
        }, () => {
            this.loadMoreData()
        });

    };

    loadMoreData() {
		const data = this.state.airlineVendorCodesGroups;
		
		const slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
		this.setState({
			pageCount: Math.ceil(data.length / this.state.perPage),
			tableData:slice
		})
    }

    getData() {        
                //var data = res.data;
                var data = this.state.airlineVendorCodesGroups;				
                var slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)               
             this.setState({
                    pageCount: Math.ceil(data.length / this.state.perPage),                   
                    tableData:slice
                }) 
    }

    onSearch(e:any){
        e.preventDefault();
        let modal = this.state.modal; 
        let fields = this.state.fields; 
        modal['modalSpinnerShow']=true; 
        var searchBy = "";  
        var desc = "";       
        let bcdcodeMaintenanceController = new BCDcodeMaintenanceController();
        
        if(fields["isIDSearch"] && !fields["isNameSearch"])
        {
            searchBy = "id";
            desc = fields["searchId"];
        }
        if(!fields["isIDSearch"] && fields["isNameSearch"])
        {
            searchBy = "name";
            desc = fields["searchName"];
        }
        var data={
            doBy:searchBy,
            description:desc
        }
        
        bcdcodeMaintenanceController.GetAirlineVendorCodesList(data).then(jsonAirlineVendorList => {
            this.setState({ airlineVendorCodesGroups: JSON.parse(JSON.stringify(jsonAirlineVendorList))});           
            this.getData()
            modal['modalSpinnerShow']=false; 
            this.setState({modal,offset:0})         
        }).catch(error => {
            console.error("There was an error!", error);
            modal['modalSpinnerShow']=false;
            this.setState({modal})
        })
    }    

    onClear(e:any)
    {
        e.preventDefault();
        let modal = this.state.modal; 
        modal['modalSpinnerShow']=true; 
        this.clearData();
        this.getAirlineVendorCodeList();
    }

    clearData()
    {
        let fields = this.state.fields
        let errors = this.state.errors;
        fields["id"] ="";
        fields["name"] = "";        
        fields["searchName"] = "";
        fields["searchId"] = "";
        fields["isEdit"] = false;    
        fields["isIDSearch"] = true; 
        fields["isNameSearch"] = true; 
        errors["id"] ="";
        errors["name"] = "";      
        this.setState({fields,errors})
    }

    onSave(e:any){
        e.preventDefault();
        let fields = this.state.fields
        let modal = this.state.modal;         
        var doBy = "";
        if(this.validateAirlineVendorCode())
        {
            modal['modalSpinnerShow']=true; 
            if(fields["isEdit"])
                doBy = "U";
            else
             doBy = "I";
            let bcdcodeMaintenanceController = new BCDcodeMaintenanceController();
            var data = {  
                    doBy:doBy,           
                    id:fields["id"],
                    name:fields["name"]                     
                }
                bcdcodeMaintenanceController.InsUpdDelAirlineVendortCode(data).then(response => { 
                if(fields["isEdit"])
                    alert('CTM Airline Vendor Code Updated')
                else
                    alert('CTM Airline Vendor Code Added') 
                this.getAirlineVendorCodeList(); 
                this.clearData();   
                modal['modalSpinnerShow']=false;  
                this.setState({modal})            
                }).catch(error => {
                    console.error("There was an error!", error)
                })   
        }
    }

    async onDelete(data) {      
        var flag = await confirm("Are you sure want to Delete?",{title:"Confirm Delete", okText:"Yes", cancelText:"No"})
        if(flag){
            let bcdcodeMaintenanceController = new BCDcodeMaintenanceController();
            var data1 = {  
                doBy:"D",           
                id:data["id"],
                name:data["name"],                     
            }
            bcdcodeMaintenanceController.InsUpdDelAirlineVendortCode(data1).then(response => { 
                alert('Data Deleted..')  
                this.getAirlineVendorCodeList();  
                this.clearData();              
            }).catch(error => {
                console.error("There was an error!", error)
            })   
        }
    }

    onEdit=(e:any,data)=>{
        e.preventDefault();
        let fields = this.state.fields
        let errors = this.state.errors;
        fields["id"] = data["id"];
        fields["name"] = data["name"];         
        fields["isEdit"] = true;
        errors["id"] ="";
        errors["name"] = ""; 
        this.setState({fields})
    }

    validateAirlineVendorCode=()=>{
        var isValid=true
        let fields = this.state.fields;
        let errors = this.state.errors;
        if(fields["id"] === "")
        {
            isValid=false;
            errors["id"] ="Enter ID";
        }
        if(fields["name"] === "")
        {
            isValid=false
            errors["name"] ="Enter Airline Vendor Name";
        }
        if(isValid && !fields["isEdit"])
        {
            var sta = this.state.airlineVendorCodesGroups.filter(item => fields["id"] === item.id);
            if(sta.length >0)
            {
                isValid=false
                alert("ID Already Exists.Please Choose Differtent");
            }
        }       
        this.setState({errors})
        return isValid;
    }
    

    getAirlineVendorCodeList =()=>{
        let modal = this.state.modal;         
        let bcdcodeMaintenanceController = new BCDcodeMaintenanceController();
        var data={
            doBy:"",
            description:""
        }
        
        bcdcodeMaintenanceController.GetAirlineVendorCodesList(data).then(jsonAirlineVendorList => {
            this.setState({ airlineVendorCodesGroups: JSON.parse(JSON.stringify(jsonAirlineVendorList))});           
            this.getData()
            modal['modalSpinnerShow']=false;  
            this.setState({modal})        
        }).catch(error => {
            console.error("There was an error!", error);
            modal['modalSpinnerShow']=false;
            this.setState({modal})
        })
    }

    render() {
        const{ loading } = this.state; 
                     
         const tdStyle = {
            width:'20%',            
            border: "2px solid #eee",
             padding:"2px"           
        };

        const tdStyle1 = {
            width:'50%',            
            border: "2px solid #eee",
             padding:"2px"           
        };
             
        const thStyle ={
            width:'20%',            
            border: "2px solid #eee",
            padding:"2px"                        
        };  
        const thStyle1 ={
            width:'50%',            
            border: "2px solid #eee",
            padding:"2px"                        
        };      
        return (
        <div className="content">
            <FormModalSpinner show={this.state.modal.modalSpinnerShow} />
            <Container fluid>
                <Row>
                    <Col sm={12}>
                        <Card border="light" style={{ width: '100%' }}>
                            <div className="header"><h4 className="title">CTM Airline Vendor Codes</h4></div>
                            <Card.Body>
                                <Alert variant="danger" style={{ display: this.state.errMsg ? "inherit" : "none"}}>{this.state.errMsg}</Alert>
                                <Row>
                                       <Col sm={1}>
                                         <FormInputs
                                                properties={{id:"id",label:"ID",type:"text",name:"id",maxlength:5,value:this.state.fields.id,className:"form-control input-sm", onChange: this.state.fields.isEdit ? "" : this.handleTextChange}}
                                                errorMsg={this.state.errors.id}
                                                fieldRequired={true}
                                                disbled={true}                                                
                                            />
                                       </Col>
                                        <Col sm={4}>
                                            <FormInputs
                                                properties={{id:"name",label:"Name",type:"text",name:"name",value:this.state.fields.name,className:"form-control input-sm", onChange: this.handleTextChange}}
                                                errorMsg={this.state.errors.name}
                                                fieldRequired={true}
                                                disbled={true}
                                            />
                                        </Col>                                         
                                       <Col sm={1} style={{marginTop:"2%"}}>
                                            <Button id="save" type="button" size="sm" disabled={loading} variant="success" onClick={(e) => this.onSave(e)}>
                                                {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" , color:"#3472F7" }}
                                                />
                                                )}
                                                {loading && <span style={{color:"#3472F7"}} >wait...</span>}
                                                {!loading && <span>Add/Update</span>}
                                            </Button>
                                        </Col>                                                                           
                                    </Row>
                                   <Row>
                                       <Col sm={2}>
                                           <FormInputs
                                                properties={{id:"searchId",label:"Search By ID:",type:"text",name:"searchId",maxlength:5,value:this.state.fields.searchId,className:"form-control input-sm", onChange: this.state.fields.isIDSearch ? this.handleTextChange  : "" }}
                                                errorMsg={this.state.errors.searchId}
                                                fieldRequired={false}
                                                disbled={true}
                                            />
                                        </Col>
                                        <Col sm={0.5} style={{marginTop:"3%",fontSize:"12px"}}>OR</Col>   
                                        <Col sm={4}>
                                           <FormInputs
                                                properties={{id:"searchName",label:"Search By Name:",type:"text",name:"searchName",value:this.state.fields.searchName,className:"form-control input-sm",  onChange: this.state.fields.isNameSearch ? this.handleTextChange  : "" }}
                                                errorMsg={this.state.errors.searchName}
                                                fieldRequired={false}
                                                disbled={true}
                                            />
                                        </Col>                                      
                                        <Col sm={1} style={{marginTop:"2%"}} >
                                            <Button id="save" type="button" size="sm" disabled={loading} variant="success" onClick={(e) => this.onSearch(e)}>
                                                {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" , color:"#3472F7" }}
                                                />
                                                )}
                                                {loading && <span style={{color:"#3472F7"}} >wait...</span>}
                                                {!loading && <span>Search</span>}
                                            </Button>
                                        </Col>
                                        <Col sm={2} style={{marginTop:"2%"}}>
                                            <Button id="save" type="button" size="sm" disabled={loading} onClick={(e) => this.onClear(e)}>
                                                {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" , color:"#3472F7" }}
                                                />
                                                )}
                                                {loading && <span style={{color:"#3472F7"}} >wait...</span>}
                                                {!loading && <span>Clear</span>}
                                            </Button>                                            
                                        </Col>
                                        <Col sm={3}></Col>                                        
                                    </Row>                                     
                                    <Row style={{marginBottom:"2%"}}>                                    
                                    </Row>                                    
                                    <Row>                                        
                                       <Col sm={12}>                                        
                                        <div>
                                            <Table hover>
                                                        <thead style={{ backgroundColor: 'yello', fontSize: 'large' }}>
                                                            <tr style={{textAlign:"center"}}>
                                                                <th style={thStyle}>ID</th>
                                                                <th style={thStyle1}>Name</th>                                                                                                                                           
                                                                <th style={thStyle}></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.tableData.map((prop, key) => {
                                                                return (
                                                                    <tr style={{textAlign:"center",cursor:"pointer"}}  key={key} > 
                                                                    <td style={tdStyle}>{prop["id"]}</td>                                                                                                                         
                                                                    <td style={tdStyle1}>{prop["name"]}</td>                                                                    
                                                                    <td style={tdStyle}>
                                                                    <tr>
                                                                            <td style={{borderTop:"0px"}}>
                                                                                <Button id="edit" type="button" size="sm" disabled={loading} onClick={(e) => this.onEdit(e,prop)}>
                                                                                    {loading && (
                                                                                    <i
                                                                                        className="fa fa-refresh fa-spin"
                                                                                        style={{ marginRight: "5px" , color:"#3472F7" }}
                                                                                    />
                                                                                    )}
                                                                                    {loading && <span style={{color:"#3472F7"}} >wait...</span>}
                                                                                    {!loading && <span>Edit</span>}
                                                                                </Button>
                                                                                <Button id="edit" type="button" size="sm" style={{ marginLeft: "10px"}} disabled={loading} variant="danger" onClick={(e) => this.onDelete(prop)}>
                                                                                    {loading && (
                                                                                    <i
                                                                                        className="fa fa-refresh fa-spin"
                                                                                        style={{ marginRight: "5px" , color:"#3472F7", }}
                                                                                    />
                                                                                    )}
                                                                                    {loading && <span style={{color:"#3472F7"}} >wait...</span>}
                                                                                    {!loading && <span>Delete</span>}
                                                                                </Button>
                                                                            </td>                                                                            
                                                                        </tr>
                                                                    </td>
                                                                    </tr>                                                                    
                                                                )
                                                            })}                                                                                                                      
                                                        </tbody>
                                                </Table>                                                                                                        
                                            </div> 
                                       </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={4}></Col>
                                         <Col><ReactPaginate
                                            previousLabel={"Prev"}
                                            nextLabel={"Next"}
                                            breakLabel={"..."}
                                            breakClassName={"break-me"}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={"pagination"}
                                            subContainerClassName={"pages pagination"}
                                            activeClassName={"active"}/> </Col>                   
                                    </Row>                                   
                           </Card.Body>                                  
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>)
    }
}